import {
  uaVersionListConstants,
  uaVersionUploadConstants,
  uaVersionDeleteConstants,
  uaVersionConstants,
} from "../_redux-constants";

export function uaVersionListReducer(
  state = {
    uaVersionListLoading: false,
    uaVersionListData: null,
    uaVersionListError: null,

    uaVersionUploadLoading: false,
    uaVersionUploadData: null,
    uaVersionUploadError: null,

    uaVersionLoading: false,
    uaVersionData: null,
    uaVersionError: null,
  },
  action
) {
  switch (action.type) {
    case uaVersionListConstants.UA_VERSION_LIST_LOADING:
      return Object.assign({}, state, {
        uaVersionListLoading: true,
        uaVersionListData: null,
        uaVersionListError: null,
      });
    case uaVersionListConstants.UA_VERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        uaVersionListLoading: false,
        uaVersionListData: action.data,
      });
    case uaVersionListConstants.UA_VERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        uaVersionListLoading: false,
        uaVersionListData: null,
        uaVersionListError: action.error,
      });
    case uaVersionUploadConstants.UA_VERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        uaVersionUploadLoading: true,
        uaVersionUploadData: null,
        uaVersionUploadError: null,
      });
    case uaVersionUploadConstants.UA_VERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        uaVersionUploadLoading: false,
        uaVersionUploadData: action.data,
      });
    case uaVersionUploadConstants.UA_VERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        uaVersionUploadLoading: false,
        uaVersionUploadData: null,
        uaVersionUploadError: action.error,
      });
    case uaVersionConstants.UA_VERSION_LOADING:
      return Object.assign({}, state, {
        uaVersionLoading: true,
        uaVersionData: null,
        uaVersionError: null,
      });
    case uaVersionConstants.UA_VERSION_SUCCESS:
      return Object.assign({}, state, {
        uaVersionLoading: false,
        uaVersionData: action.data,
      });
    case uaVersionConstants.UA_VERSION_FAILURE:
      return Object.assign({}, state, {
        uaVersionLoading: false,
        uaVersionData: null,
        uaVersionError: action.error,
      });
    case uaVersionDeleteConstants.UA_VERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        uaVersionDeleteLoading: true,
        uaVersionDeleteData: null,
        uaVersionDeleteError: null,
      });
    case uaVersionDeleteConstants.UA_VERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        uaVersionDeleteLoading: false,
        uaVersionDeleteData: action.data,
      });
    case uaVersionDeleteConstants.UA_VERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        uaVersionDeleteLoading: false,
        uaVersionDeleteData: null,
        uaVersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
